import {
	ChangeDetectionStrategy,
	Component,
	computed,
	ContentChild,
	input,
	InputSignal,
	Signal,
	TemplateRef,
} from '@angular/core'
import { ColumnSettingsInterface } from '@shared/components/common/table/core/interfaces/column-settings.interface'

@Component({
	selector: 'app-table-column',
	templateUrl: 'table-column.component.html',
	styleUrl: 'table-column.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableColumnComponent<PropSort, Column> {
	protected readonly defaultSettings: Partial<ColumnSettingsInterface<PropSort, Column>> = {
		titlePath: '',
		canSort: false,
		contentView: 'ellipsis',
		spreadContent: 'flex-start',
		minWidthPx: 60,
		maxWidthPx: 90,
	}
	@ContentChild(TemplateRef) columnTemplate: TemplateRef<unknown> | null = null

	public item: InputSignal<unknown> = input<unknown>()

	public settings: InputSignal<ColumnSettingsInterface<PropSort, Column> | null> = input<ColumnSettingsInterface<
		PropSort,
		Column
	> | null>(null)

	// Публичный так как используется в компоненте таблицы
	public resultSettings: Signal<ColumnSettingsInterface<PropSort, Column>> = computed<
		ColumnSettingsInterface<PropSort, Column>
	>((): ColumnSettingsInterface<PropSort, Column> => {
		return {
			...this.defaultSettings,
			...this.settings(),
		}
	})
}
